module.exports = __webpack_public_path__ + "2eb4577ae2181c3d404b59c98d68f6bd.jpg";